document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('aria-controls');
      var menu = document.getElementById(targetId);
      if (!menu) return;
      var isHidden = menu.classList.contains('hidden');
      menu.classList.toggle('hidden');
      btn.setAttribute('aria-expanded', String(isHidden));
    });
  });

  // Search panel toggle
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('header');
      var panel = header ? header.querySelector('[data-search-panel]') : null;
      if (!panel) return;
      panel.classList.toggle('hidden');
      if (!panel.classList.contains('hidden')) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  });

  // Nav shadow on scroll
  document.querySelectorAll('[data-navbar]').forEach(function (navbar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        navbar.classList.add('nav-scrolled');
      } else {
        navbar.classList.remove('nav-scrolled');
      }
    });
  });

  // Scroll reveal animations
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.reveal').forEach(function (el) {
    observer.observe(el);
  });

  // Product page: scrollable/swipeable main image, thumbnails scroll to position
  var mainScroller = document.querySelector('[data-main-image-scroller]');
  if (mainScroller) {
    var slides = mainScroller.querySelectorAll('[data-main-image-slide]');
    document.querySelectorAll('[data-thumb-index]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        var target = slides[index];
        if (target) {
          mainScroller.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  // Keep the hidden variant ID in sync with swatch/select selections
  var variantScript = document.getElementById('ProductVariantsJSON');
  var hiddenIdField = document.getElementById('SelectedVariantId');
  if (variantScript && hiddenIdField) {
    var variants = JSON.parse(variantScript.textContent);
    var optionWrappers = document.querySelectorAll('[data-option-index]');

    function currentSelections() {
      var selections = [];
      optionWrappers.forEach(function (wrapper) {
        var index = parseInt(wrapper.getAttribute('data-option-index'), 10);
        var activeSwatch = wrapper.querySelector('.product-option__swatch-btn.is-selected, [data-option-value].is-selected');
        var select = wrapper.querySelector('select');
        if (activeSwatch) {
          selections[index] = activeSwatch.getAttribute('data-option-value');
        } else if (select) {
          selections[index] = select.value;
        }
      });
      return selections;
    }

    function updateVariant() {
      var selections = currentSelections();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selections[i]; });
      });
      if (match) {
        hiddenIdField.value = match.id;
      }
    }

    optionWrappers.forEach(function (wrapper) {
      wrapper.addEventListener('click', function (e) {
        if (e.target.closest('[data-option-value]')) {
          wrapper.querySelectorAll('[data-option-value]').forEach(function (btn) {
            btn.classList.remove('is-selected');
          });
          e.target.closest('[data-option-value]').classList.add('is-selected');
          updateVariant();
        }
      });
      var select = wrapper.querySelector('select');
      if (select) select.addEventListener('change', updateVariant);
    });
  }

  // Product customization: per-Bible engraving + per-Bible gift box
  (function () {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var engravingMaster  = form.querySelector('[data-engraving-master-toggle]');
    var giftboxMaster    = form.querySelector('[data-giftbox-master-toggle]');
    var rowsWrapper       = form.querySelector('[data-customize-rows-wrapper]');
    var rowsContainer     = form.querySelector('[data-customize-rows]');
    var engravingJsonEl   = form.querySelector('[data-engraving-variants-json]');
    var giftboxJsonEl     = form.querySelector('[data-giftbox-options-json]');
    var processingNotice  = form.querySelector('[data-processing-notice]');
    var processingAck     = form.querySelector('[data-processing-ack]');
    var qtyField          = document.getElementById('Quantity');

    if (!engravingMaster && !giftboxMaster) return;

    var engravingVariants = [];
    if (engravingJsonEl) {
      try { engravingVariants = JSON.parse(engravingJsonEl.textContent); } catch (e) { engravingVariants = []; }
    }
    var giftboxOptions = [];
    if (giftboxJsonEl) {
      try { giftboxOptions = JSON.parse(giftboxJsonEl.textContent); } catch (e) { giftboxOptions = []; }
    }

    function currentQty() {
      return qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;
    }

    function engravingOptionsHtml(selectedId) {
      var html = '';
      engravingVariants.forEach(function (v) {
        if (v.available) {
          html += '<option value="' + v.id + '"' + (String(v.id) === String(selectedId) ? ' selected' : '') + '>' + v.title + '</option>';
        } else {
          html += '<option value="" disabled>' + v.title + ' — Sold out</option>';
        }
      });
      return html;
    }

    function giftboxOptionsHtml(selectedId) {
      var html = '';
      giftboxOptions.forEach(function (b) {
        if (b.available) {
          html += '<option value="' + b.id + '"' + (String(b.id) === String(selectedId) ? ' selected' : '') + '>' + b.label + '</option>';
        } else {
          html += '<option value="" disabled>' + b.label + ' — Sold out</option>';
        }
      });
      return html;
    }

    function updateProcessingNoticeVisibility() {
      if (!processingNotice) return;
      var anyChecked;
      if (currentQty() === 1) {
        // single Bible: engraving is "on" whenever the master toggle + fields exist, no per-row checkbox to check
        anyChecked = !!(engravingMaster && engravingMaster.checked);
      } else {
        anyChecked = rowsContainer ? Array.prototype.some.call(
          rowsContainer.querySelectorAll('[data-row-engrave-toggle]'),
          function (cb) { return cb.checked; }
        ) : false;
      }
      processingNotice.classList.toggle('hidden', !anyChecked);
      if (!anyChecked && processingAck) processingAck.checked = false;
    }

    function renderRows() {
      if (!rowsContainer) return;
      var qty = currentQty();
      var showEngraving = engravingMaster && engravingMaster.checked;
      var showGiftbox   = giftboxMaster && giftboxMaster.checked;

      if (qty === 1) {
        // Single Bible: no redundant "engrave this Bible" checkbox - the master
        // toggle already said yes, so go straight to the fields.
        var prevSingle = rowsContainer.querySelector('[data-customize-row]');
        var prevEngVariant = '', prevName = '', prevBoxVariant = '';
        if (prevSingle) {
          var es = prevSingle.querySelector('[data-row-engrave-variant]');
          var ni = prevSingle.querySelector('[data-row-name-input]');
          var bs = prevSingle.querySelector('[data-row-giftbox-variant]');
          if (es) prevEngVariant = es.value;
          if (ni) prevName = ni.value;
          if (bs) prevBoxVariant = bs.value;
        }
        var nameEsc = prevName.replace(/"/g, '&quot;');

        var html = '<div class="border border-stone-200 rounded-sm p-4 space-y-3" data-customize-row data-row-index="0">';
        if (showEngraving) {
          html += '' +
            '<div class="space-y-2" data-row-engrave-fields data-row-implicit-on="true">' +
              '<div>' +
                '<label class="block text-xs uppercase tracking-widest text-stone-500 mb-1">Color &amp; font</label>' +
                '<select data-row-engrave-variant class="w-full border border-stone-300 px-3 py-2 text-sm focus:outline-none focus:border-amber-800">' +
                  engravingOptionsHtml(prevEngVariant) +
                '</select>' +
              '</div>' +
              '<div>' +
                '<label class="block text-xs uppercase tracking-widest text-stone-500 mb-1">Name to engrave</label>' +
                '<input type="text" data-row-name-input maxlength="30" value="' + nameEsc + '" class="w-full border border-stone-300 px-3 py-2 text-sm focus:outline-none focus:border-amber-800" placeholder="e.g. John Smith">' +
              '</div>' +
            '</div>';
        }
        if (showGiftbox) {
          html += '' +
            '<div data-row-giftbox-fields data-row-implicit-on="true">' +
              '<label class="block text-xs uppercase tracking-widest text-stone-500 mb-1">Gift box</label>' +
              '<select data-row-giftbox-variant class="w-full border border-stone-300 px-3 py-2 text-sm focus:outline-none focus:border-amber-800">' +
                giftboxOptionsHtml(prevBoxVariant) +
              '</select>' +
            '</div>';
        }
        html += '</div>';
        rowsContainer.innerHTML = html;
        updateProcessingNoticeVisibility();
        return;
      }

      // Quantity 2+: per-row opt-in checkboxes, since each copy can differ
      var existing = [];
      rowsContainer.querySelectorAll('[data-customize-row]').forEach(function (row) {
        var engCb = row.querySelector('[data-row-engrave-toggle]');
        var engSel = row.querySelector('[data-row-engrave-variant]');
        var nameInput = row.querySelector('[data-row-name-input]');
        var boxCb = row.querySelector('[data-row-giftbox-toggle]');
        var boxSel = row.querySelector('[data-row-giftbox-variant]');
        existing.push({
          engChecked: engCb ? engCb.checked : false,
          engVariant: engSel ? engSel.value : '',
          name: nameInput ? nameInput.value : '',
          boxChecked: boxCb ? boxCb.checked : false,
          boxVariant: boxSel ? boxSel.value : ''
        });
      });

      var html = '';
      for (var i = 0; i < qty; i++) {
        var prev = existing[i] || { engChecked: false, engVariant: '', name: '', boxChecked: false, boxVariant: '' };
        var nameEsc2 = prev.name.replace(/"/g, '&quot;');

        html += '<div class="border border-stone-200 rounded-sm p-4 space-y-3" data-customize-row data-row-index="' + i + '">';
        html += '<p class="text-sm font-medium text-stone-700">Bible ' + (i + 1) + ' of ' + qty + '</p>';

        if (showEngraving) {
          html += '' +
            '<div>' +
              '<label class="flex items-center gap-2 text-sm text-stone-700">' +
                '<input type="checkbox" data-row-engrave-toggle class="accent-amber-800"' + (prev.engChecked ? ' checked' : '') + '>' +
                'Engrave this Bible' +
              '</label>' +
              '<div class="space-y-2 mt-2 ml-6' + (prev.engChecked ? '' : ' hidden') + '" data-row-engrave-fields>' +
                '<div>' +
                  '<label class="block text-xs uppercase tracking-widest text-stone-500 mb-1">Color &amp; font</label>' +
                  '<select data-row-engrave-variant class="w-full border border-stone-300 px-3 py-2 text-sm focus:outline-none focus:border-amber-800">' +
                    engravingOptionsHtml(prev.engVariant) +
                  '</select>' +
                '</div>' +
                '<div>' +
                  '<label class="block text-xs uppercase tracking-widest text-stone-500 mb-1">Name to engrave</label>' +
                  '<input type="text" data-row-name-input maxlength="30" value="' + nameEsc2 + '" class="w-full border border-stone-300 px-3 py-2 text-sm focus:outline-none focus:border-amber-800" placeholder="e.g. John Smith">' +
                '</div>' +
              '</div>' +
            '</div>';
        }

        if (showGiftbox) {
          html += '' +
            '<div>' +
              '<label class="flex items-center gap-2 text-sm text-stone-700">' +
                '<input type="checkbox" data-row-giftbox-toggle class="accent-amber-800"' + (prev.boxChecked ? ' checked' : '') + '>' +
                'Add a gift box' +
              '</label>' +
              '<div class="mt-2 ml-6' + (prev.boxChecked ? '' : ' hidden') + '" data-row-giftbox-fields>' +
                '<select data-row-giftbox-variant class="w-full border border-stone-300 px-3 py-2 text-sm focus:outline-none focus:border-amber-800">' +
                  giftboxOptionsHtml(prev.boxVariant) +
                '</select>' +
              '</div>' +
            '</div>';
        }

        html += '</div>';
      }
      rowsContainer.innerHTML = html;

      rowsContainer.querySelectorAll('[data-row-engrave-toggle]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var fields = cb.closest('[data-customize-row]').querySelector('[data-row-engrave-fields]');
          if (fields) fields.classList.toggle('hidden', !cb.checked);
          updateProcessingNoticeVisibility();
        });
      });
      rowsContainer.querySelectorAll('[data-row-giftbox-toggle]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var fields = cb.closest('[data-customize-row]').querySelector('[data-row-giftbox-fields]');
          if (fields) fields.classList.toggle('hidden', !cb.checked);
        });
      });

      updateProcessingNoticeVisibility();
    }

    function updateWrapperVisibility() {
      var show = (engravingMaster && engravingMaster.checked) || (giftboxMaster && giftboxMaster.checked);
      if (rowsWrapper) rowsWrapper.classList.toggle('hidden', !show);
      if (show) renderRows();
    }

    if (engravingMaster) engravingMaster.addEventListener('change', updateWrapperVisibility);
    if (giftboxMaster) giftboxMaster.addEventListener('change', updateWrapperVisibility);
    if (qtyField) {
      qtyField.addEventListener('input', function () {
        if ((engravingMaster && engravingMaster.checked) || (giftboxMaster && giftboxMaster.checked)) renderRows();
      });
    }

    form.addEventListener('submit', function (e) {
      var engravingOn = engravingMaster && engravingMaster.checked;
      var giftboxOn   = giftboxMaster && giftboxMaster.checked;
      if (!engravingOn && !giftboxOn) return; // nothing customized - let the normal form submit run

      e.preventDefault();

      var hiddenId = document.getElementById('SelectedVariantId');
      var qty = currentQty();
      var items = [];
      var anyRowEngraved = false;
      var rows = rowsContainer ? rowsContainer.querySelectorAll('[data-customize-row]') : [];
      var singleImplicit = (qty === 1);

      for (var i = 0; i < qty; i++) {
        var row = rows[i];
        var wantsEngrave = false;
        var wantsBox = false;
        var engVariantId = null;
        var boxVariantId = null;
        var name = '';

        if (row) {
          if (singleImplicit) {
            // No per-row checkbox exists for qty 1 - the master toggle is the decision.
            wantsEngrave = engravingOn && !!row.querySelector('[data-row-engrave-fields]');
            wantsBox = giftboxOn && !!row.querySelector('[data-row-giftbox-fields]');
          } else {
            var engCb = row.querySelector('[data-row-engrave-toggle]');
            var boxCb = row.querySelector('[data-row-giftbox-toggle]');
            wantsEngrave = engravingOn && engCb && engCb.checked;
            wantsBox = giftboxOn && boxCb && boxCb.checked;
          }

          if (wantsEngrave) {
            var engSel = row.querySelector('[data-row-engrave-variant]');
            var nameInput = row.querySelector('[data-row-name-input]');
            name = nameInput ? nameInput.value.trim() : '';
            engVariantId = engSel ? engSel.value : '';

            if (!name) {
              alert(qty > 1 ? ('Please enter a name for Bible ' + (i + 1) + ', or uncheck engraving for that copy.') : 'Please enter the name you would like engraved.');
              if (nameInput) nameInput.focus();
              return;
            }
            if (!engVariantId) {
              alert('Please choose a color and font for the engraving.');
              return;
            }
            anyRowEngraved = true;
          }

          if (wantsBox) {
            var boxSel = row.querySelector('[data-row-giftbox-variant]');
            boxVariantId = boxSel ? boxSel.value : '';
            if (!boxVariantId) {
              alert('Please choose a gift box.');
              return;
            }
          }
        }

        var mainItem = { id: parseInt(hiddenId.value, 10), quantity: 1 };
        if (wantsEngrave) {
          var engSelForTitle = row.querySelector('[data-row-engrave-variant]');
          var styleTitle = engSelForTitle.options[engSelForTitle.selectedIndex].text;
          mainItem.properties = {
            'Engraving Name': name,
            'Engraving Style': styleTitle
          };
        }
        items.push(mainItem);

        if (wantsEngrave) {
          items.push({
            id: parseInt(engVariantId, 10),
            quantity: 1,
            properties: { 'Engraved for': name }
          });
        }
        if (wantsBox) {
          items.push({ id: parseInt(boxVariantId, 10), quantity: 1 });
        }
      }

      if (anyRowEngraved && (!processingAck || !processingAck.checked)) {
        alert('Please confirm you understand engraving adds 3–5 business days to processing time.');
        return;
      }

      var submitBtn = form.querySelector('[name="add"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (res.ok) {
            window.location.href = '/cart';
          } else {
            alert(res.data.description || 'Sorry, that could not be added to your cart.');
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
          }
        })
        .catch(function () {
          alert('Something went wrong adding to your cart. Please try again.');
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
        });
    });
  })();
// Final sale acknowledgment gate for Artisan Sale / Seconds for Sale items
  var finalSaleBtn = document.querySelector('[data-requires-final-sale-ack]');
  var finalSaleAck = document.querySelector('[data-final-sale-ack]');
  if (finalSaleBtn && finalSaleAck) {
    var productForm = document.getElementById('ProductForm');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        if (!finalSaleAck.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('Please confirm you understand this item is final sale before adding to cart.');
          finalSaleAck.focus();
        }
      }, true); // capture phase, so this runs before the customization handler
    }
  }

  // Cart line delete buttons
  document.querySelectorAll('[data-remove-line]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-remove-line');
      var row = btn.closest('[data-cart-row]');
      btn.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          alert('Something went wrong removing that item. Please try again.');
          btn.disabled = false;
        });
    });
  });
});